'use client';

import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

export const TypewriterContainer = styled.div`
  ${props => props.theme.typography[props.$typography]};
  ${props => props.theme.fontFamily.fuzzyBubbles};
  display: inline-flex;
  align-items: center;
  color: ${props => props.theme.colors.get(props.$fontColor)};
  height: 1lh;
  line-height: 80px;

  @media ${props => props.theme.tablet} {
    min-height: 1lh;
    overflow: visible;
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;

export const Text = styled.span``;

export const Cursor = styled.span`
  display: inline-block;
  margin-left: 3px;
  background-color: ${props => props.theme.colors.get(props.$fontColor)};
  animation: ${blink} 0.75s step-end infinite;
  border-radius: 2px;
  width: 5px;
  height: 0.8em;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
